<script>
import { getNewsList } from "../api/agri";
export default {
    name: "demo",
    data() {
        return {
            data_list: [],
            config: {
                header: [], // 列头
                data: [
                    // ...更多数据
                ],
                rowNum: 6,
                carousel: "page",
                waitTime: 10000,
                columnWidth: [20],
                // 其他配置选项，例如速度、滚动方向等
                // 参见官方文档获取更多配置选项
            },
        };
    },

    methods: {
        handleFlag() {
            this.$emit("handleChange");
        },
        showNewsSingleDialog(data, data_list) {
            // console.log( this.data_list[data.rowIndex].redirect_url,,9876)

            this.$emit("newsSingleChange", this.data_list[data.rowIndex], this.data_list);
        },
        showNewsAllDialog() {},
    },
    computed: {
        data_list_table() {
            return this.data_list.map((item, index) => {
                return item.title;
            });
        },
    },
    mounted() {
        getNewsList().then((res) => {
            if (res.data.msg == "ok") {
                // alert("获取成功")
                this.data_list = res.data.data;
                this.config.data = this.data_list.map((item, index) => {
                    return [
                        '<i data-v-55a9dae3="" class="icon ivu-icon ivu-icon-md-volume-up"></i>',
                        item.title,
                    ];
                });
                this.config = { ...this.config };
                console.log(this.config, 9876);
            }
            console.log(res.data, 8989);
        });
    },
};
</script>

<template>
    <div class="news">
        <header>
            <div class="header-left">
                涉农资讯
                <img
                    @click="handleFlag"
                    class="header-left-img"
                    src="../assets/change-icon.png.png"
                />
            </div>
            <div class="header-right" @click="$emit('showAllNewsDialog', data_list)">
                更多<i
                    data-v-2bffba5a=""
                    class="show-more-icon ivu-icon ivu-icon-ios-arrow-forward"
                ></i>
            </div>
        </header>
        <div class="content">
            <!--        <vue-seamless-scroll :data="data_list" :class-option="classOption" >-->
            <!--        <div v-for="(item,i) in data_list">-->

            <!--            <div :class='{"content-text":true,"active-color":i%2==0}' @click="showNewsSingleDialog(item,data_list)">-->
            <!--                &nbsp;<i data-v-55a9dae3="" class="icon ivu-icon ivu-icon-md-volume-up"></i>-->
            <!--                &nbsp;<span>{{item.title}}</span>-->
            <!--            </div>-->
            <!--        </div>-->

           
            <div v-if="config.data.length == 0" style="width: 100%; height: 100%;display: flex;justify-content: center;align-items: center;">
               <div>
                暂无涉农资讯
               </div> 
            </div>
            <dv-scroll-board
                v-else
                    @click="showNewsSingleDialog"
                    :config="config"
                    style="cursor: pointer; width: 100%; height: 100%; opacity: 0.5"
            />

            <!--        </vue-seamless-scroll>-->
        </div>
    </div>
</template>

<style scoped>
.news {
    position: absolute;
    top: calc((100% - 80px) / 3 + 40px);
    right: 20px;
    width: 26.615vw;
    height: calc((100% - 80px) / 3);
    background-color: rgba(0, 40, 69, 0.8);
    border-radius: 0.5vw;
}
header {
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-left {
    font-size: 1.172vw;
    color: #ffffff;
    padding-left: 1vw;
}
.header-left-img {
    height: 1.5vh;
    cursor: pointer;
}
.header-right {
    padding-right: 1vw;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.content {
    position: relative;
    width: 100%;
    height: 80%;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-bottom: 1vw;
    font-size: 0.8vw;
    color: #5d768a;
    overflow: hidden;
}
.content-text {
    height: 4vh;
    line-height: 4vh;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
}

.active-color {
    background: #002b4c;
}
/deep/ .dv-scroll-board {
    color: #aaa;
}
.rows {
    font-size: 0.8vw !important;
}
/deep/ .row-item {
    font-size: 0.8vw !important;
}
</style>
